var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"width":"100%"}},[_c('v-card-text',{staticClass:"pa-6"},[_c('div',[_c('LineChart',{staticStyle:{"width":"100%","position":"relative"},attrs:{"chartdata":_vm.chartData,"options":_vm.chartOptions}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }